import { Mail, Phone, Clock, HelpCircle, AlertTriangle, Settings } from 'lucide-react';

export const SupportPage = () => {
    return (
        <div className="max-w-6xl mx-auto px-4 py-6">
            <h1 className="text-2xl font-bold text-slate-800 mb-6">Support Center</h1>

            <p className="text-lg text-slate-600 max-w-3xl mb-6">
                If you need help using the site, we're glad to assist. Or if you would like to report a problem,
                we're standing by to remedy the situation.
            </p>
            {/* Support Cards */}
            <div className="grid md:grid-cols-2 gap-8 mb-12">
                {/* General Support Card */}
                <div className="bg-white rounded-lg shadow-md overflow-hidden border border-slate-200">
                    <div className="bg-blue-600 p-4">
                        <h2 className="text-xl font-semibold text-white flex items-center">
                            <HelpCircle className="w-6 h-6 mr-2" />
                            General Support
                        </h2>
                    </div>
                    <div className="p-6">
                        <h3 className="text-lg font-medium text-slate-800 mb-3">Need help?</h3>
                        <p className="text-slate-600 mb-6">
                            Our staff is ready to assist you Monday through Friday, from 8:00 AM to 5:00 PM CST.
                        </p>

                        <div className="space-y-4">
                            <div className="flex items-start">
                                <Mail className="w-5 h-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
                                <div>
                                    <p className="font-medium text-slate-700">Email</p>
                                    <a href="mailto:sviorders@stewart.com" className="text-blue-600 hover:underline">
                                        sviorders@stewart.com
                                    </a>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <Phone className="w-5 h-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
                                <div>
                                    <p className="font-medium text-slate-700">Call</p>
                                    <a href="tel:8665620123" className="text-blue-600 hover:underline">
                                        866-562-0123
                                    </a>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <Clock className="w-5 h-5 text-blue-600 mt-0.5 mr-3 flex-shrink-0" />
                                <div>
                                    <p className="font-medium text-slate-700">Hours of Operation</p>
                                    <p className="text-slate-600">Monday - Friday, 8:00 AM - 5:00 PM CST</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Technical Support Card */}
                <div className="bg-white rounded-lg shadow-md overflow-hidden border border-slate-200">
                    <div className="bg-green-600 p-4">
                        <h2 className="text-xl font-semibold text-white flex items-center">
                            <Settings className="w-6 h-6 mr-2" />
                            Technical Support
                        </h2>
                    </div>
                    <div className="p-6">
                        <h3 className="text-lg font-medium text-slate-800 mb-3">Profile Settings & Configuration</h3>
                        <p className="text-slate-600 mb-6">
                            For help with profile settings, account configurations, and technical assistance,
                            please contact our dedicated technical support team.
                        </p>

                        <div className="space-y-4">
                            <div className="flex items-start">
                                <Mail className="w-5 h-5 text-green-600 mt-0.5 mr-3 flex-shrink-0" />
                                <div>
                                    <p className="font-medium text-slate-700">Email</p>
                                    <a href="mailto:valuationvm@stewart.com" className="text-green-600 hover:underline">
                                        valuationvm@stewart.com
                                    </a>
                                </div>
                            </div>

                            <div className="flex items-start">
                                <Clock className="w-5 h-5 text-green-600 mt-0.5 mr-3 flex-shrink-0" />
                                <div>
                                    <p className="font-medium text-slate-700">Response Time</p>
                                    <p className="text-slate-600">We aim to respond to all inquiries within 24 hours during business days.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Report a Problem Section */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden border border-slate-200">
                <div className="bg-orange-600 p-4">
                    <h2 className="text-xl font-semibold text-white flex items-center">
                        <AlertTriangle className="w-6 h-6 mr-2" />
                        Report a Problem
                    </h2>
                </div>
                <div className="p-6">
                    <p className="text-slate-600 mb-6">
                        If you've encountered a technical issue or found a bug on our platform,
                        please let us know so we can address it promptly.
                    </p>

                    <div className="bg-orange-50 border border-orange-200 rounded-md p-4 mb-6">
                        <h4 className="font-medium text-slate-800 mb-2">When reporting an issue, please include:</h4>
                        <ul className="list-disc pl-5 text-slate-600 space-y-1">
                            <li>A detailed description of the problem</li>
                            <li>Steps to reproduce the issue</li>
                            <li>The browser and device you were using</li>
                            <li>Screenshots, if possible</li>
                        </ul>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                        <a
                            href="mailto:valuationvm@stewart.com?subject=Issue Report"
                            className="inline-flex items-center justify-center bg-orange-600 hover:bg-orange-700 text-white font-medium py-2 px-6 rounded-md transition-colors"
                        >
                            <Mail className="w-5 h-5 mr-2" />
                            Report via Email
                        </a>
                        <span className="text-slate-500">{'or call us at '}
                            <a href="tel:8665620123" className="text-blue-600 hover:underline">866-562-0123</a>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};
